import React, { PureComponent } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, post, put } from '../../redux/modules/team';
import FieldInput from '../../components/Field/Field';
import Image from '../../components/image/Image';
import Editor from '../../components/editor/Editor';

const FORM_NAME = 'PartnerForm';

const Person = () => {
  return (
    <div>
      <div className="row">
        <div className="col-xs-5">
          <Field
            label="Name"
            name="name"
            component={FieldInput}/>

          <Field
            label="Small description"
            name="description"
            component={FieldInput}/>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-5">
          <Field
            name="photo"
            component={Image}/>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12">
          <Field
            name="body"
            component={Editor}/>
        </div>
      </div>
    </div>
  );
};

const Generic = () => {
  return (
    <div className="row">
      <div className="col-xs-5">
        <Field
          label="Name"
          name="name"
          component={FieldInput}/>
      </div>
    </div>
  );
};

class PartnerForm extends PureComponent {

  handlerSubmit(values) {

    const { getAction, putAction, postAction, close } = this.props;

    let newData = { ...values };

    if (newData.type === 'generic') {
      newData = {
        name: values.name,
        body: '-',
        description: '-',
        photo: '-',
        type: 'generic'
      }
    }

    if (values.id > 0) {
      return putAction(values.id, newData)
        .then(() => {
          getAction();
          close();
        });
    }

    return postAction(newData).then(() => {
      getAction();
      close();
    });
  }

  render() {
    const { myValues, handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <form
        className="planet-form planet-form__team"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <div className="row">
          <div className="col-xs-4">
            <Field
              className="form-control"
              name="type"
              component="select">
              <option/>
              <option value="person">Person</option>
              <option value="generic">Generic</option>
            </Field>
          </div>
        </div>

        {
          myValues.type === 'person' && <Person/>
        }
        {
          myValues.type === 'generic' && <Generic/>
        }

        <div className="clearfix"></div>
        <div className="col-lg-12 text-right form-buttons">
          <button disabled={pristine || submitting} loading={submitting} type="submit"
                  className="btn btn-primary btn-xl">Save
          </button>
          <button disabled={pristine || submitting} loading={submitting} type="button"
                  className="btn btn-primary btn-xl"
                  onClick={reset}>Clear
          </button>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      postAction: post,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/team-member/index.js